// extracted by mini-css-extract-plugin
export default {"footer":"WizardModal_footer__EtBMR","sandbox":"WizardModal_sandbox__7f3Ak","link":"WizardModal_link__3zJ0A"};